import domainDictionary from "./domainDictionary";

export default {
    linkInsert(link) {
        let host = getHost(link);
        gtag('event', 'link-insert', {
            'event_category': 'main-page',
            'event_label': host
        });
    },
    linkSubmit(link) {
        let host = getHost(link);
        gtag('event', 'link-submit', {
            'event_category': 'main-page',
            'event_label': host
        });
    },
    profileSubmit(query) {
        gtag('event', 'profile-submit', {
            'event_category': 'main-page',
            'event_label': true
        });
    },
    searchDownload(url) {
        gtag('event', 'search-download', {
            'event_category': 'vidacha',
            'event_label': true
        });
    },
    downloadClick(link, format) {
        let host = getHost(link);
        gtag('event', 'download-click', {
            'event_category': 'vidacha',
            'event_label': host,
            'dimension1': format
        });
    },
    showResults(link) {
        let host = getHost(link);
        gtag('event', 'show', {
            'event_category': 'vidacha',
            'event_label': host
        });
    },
    showError(e) {
        if (!e) {
            gtag('event', 'not_found', {
                'event_category': 'vidacha',
                'event_label': 'fatal'
            });
            return;
        }
        if (e.timeout) {
            gtag('event', 'not_found', {
                'event_category': 'vidacha',
                'event_label': 'timeout_exeeded'
            });
            return;
        }
        if (e.supported_resource === null) {
            gtag('event', 'not_found', {
                'event_category': 'vidacha',
                'event_label': 'not_supported'
            });
            return;
        }
        if (e.success === false || [100, 101, 102, 103].indexOf(e.code) > -1) {
            gtag('event', 'not_found', {
                'event_category': 'vidacha',
                'event_label': 'link_not_found'
            });
            return;
        }
        if (e.status >= 400 && e.status !== 401) {
            gtag('event', 'not_found', {
                'event_category': 'vidacha',
                'event_label': 'link_not_found'
            });
            return;
        }
        if (e.status === 401) {
            gtag('event', 'response-error', {
                'event_category': 'request-signing',
                'event_label': e.data.error_code || e.data.error || ''
            });
            return
        }
        if (e.blacklist) {
            let serverName = e.srv || '';
            let hosting = e.hosting || '?';
            if (e.hosting_id && e.hosting_id == 101) {
                hosting = 101;
            }
            gtag('event', 'blacklist', {
                'event_category': 'failure',
                'event_label': 'blacklist',
                'dimension1': serverName
            });
        }
    },
    sendWebVitalsToGA({ name, delta, id }) {
        gtag('event', name, {
            value: delta,
            value_category: getValueCategory(name, delta),
            metric_id: id,
        });

        function getValueCategory(name, delta) {
            switch (name) {
                case 'LCP':
                    return delta <= 2500 ? 'good' : delta <= 4000 ? 'medium' : 'bad';
                case 'FID':
                    return delta <= 100 ? 'good' : delta <= 300 ? 'medium' : 'bad';
                case 'CLS':
                    return delta <= 0.1 ? 'good' : delta <= 0.25 ? 'medium' : 'bad';
                case 'FCP':
                    return delta <= 1800 ? 'good' : delta <= 3000 ? 'medium' : 'bad';
                case 'INP':
                    return delta <= 200 ? 'good' : delta <= 500 ? 'medium' : 'bad';
                case 'TTFB':
                    return delta <= 800 ? 'good' : delta <= 1800 ? 'medium' : 'bad';
                default:
                    return 'unknown metric';
            }
        };
    },
}

export function getHost(link) {
    let aTmp = document.createElement('a');
    aTmp.href = link;
    return domainDictionary(aTmp.hostname);
}
